export default __webpack_public_path__ + "static/media/TimesheetIcon.848661ac.svg";